export default __webpack_public_path__ + "static/media/downloadappstore.17a326f8.png";